module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lXhRf"))).then(() => module.bundle.root('ikE14'));